import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import WxLinkDialog from '../components/WxLinkDialog';
import C from '../colors';

import UserInfoPage from './users/info/index';
import Orders from './orders/index';
import OrdersDeleted from './orders/deleted';
import Notifications from './users/notifications';
import Packages from './packages/index'
import PackageCreate from './packages/create'
import PackageEdit from './packages/edit'
import OrdersCreate from './orders/create'
import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import DeleteConfirmationDialog from '../components/DeleteConfirmationDialog';
import ChargeDialog from '../components/ChargeDialog';
import SubscriptionIndex from './users/subscription/index';
import InvoiceIndex from './users/invoice/index';
import WithdrawIndex from './users/withdraw/index';
import IncomesIndex from './users/incomes/index';
import SmsLogs from './users/sms/index';
import Support from './users/support';
import Watermark from './users/setting/watermark';
import Resolution from './users/setting/resolution';
import SubscriptionAlert from '../components/SubscriptionAlert';
import SpaceAlert from '../components/SpaceAlert';

import Step1 from './orders/steps/step1';
import Step2 from './orders/steps/step2';
import Step3 from './orders/steps/step3';
import Step4 from './orders/steps/step4';
import Step5 from './orders/steps/step5';
import AccessStats from './orders/accessStats';

import Tag from './users/setting/tag';

const Layout = inject('userStore', 'chargeStore')(observer(({ userStore, chargeStore }) => {
  const location = useLocation();
  // Signed-in photographers opening app.picsect.com go straight to orders, not via /login.
  const hasToken = Boolean(userStore.token || localStorage.getItem('token'));
  useEffect(() => {
    if (userStore.token || localStorage.getItem('token')) {
      userStore.refreshInfo();
    }
  }, [userStore]);

  // Renewal links handed out by AI assistants: /user/info?renew=1
  useEffect(() => {
    if (new URLSearchParams(location.search).get('renew') === '1') {
      chargeStore.openChargeDialog();
    }
  }, [location.search, chargeStore]);

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: '232px 1fr',
      height: '100vh',
      background: C.paper,
      color: C.ink,
      fontFamily: '"Inter", "Noto Sans SC", -apple-system, sans-serif',
    }}>
      <Sidebar />
      <main style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>
        <TopBar />
        <div style={{ flex: 1, overflow: 'auto' }}>
          <Routes>
            <Route path="/user/support" element={<Support />} />
            <Route path="/user/orders" element={<Orders />} />
            <Route path="/user/notifications" element={<Notifications />} />
            <Route path="/user/recycleBin" element={<OrdersDeleted />} />
            <Route path="/user/orders/create" element={<OrdersCreate />} />
            <Route path="/user/orders/:orderId/step1" element={<Step1 />} />
            <Route path="/user/orders/:orderId/step2" element={<Step2 />} />
            <Route path="/user/orders/:orderId/step3" element={<Step3 />} />
            <Route path="/user/orders/:orderId/step4" element={<Step4 />} />
            <Route path="/user/orders/:orderId/step5" element={<Step5 />} />
            <Route path="/user/orders/:orderId/accessStats" element={<AccessStats />} />
            <Route path="/user/packages" element={<Packages />} />
            <Route path="/user/packages/create" element={<PackageCreate />} />
            <Route path="/user/packages/:packageId/edit" element={<PackageEdit />} />
            <Route path="/user/info" element={<UserInfoPage />} />
            <Route path="/user/info/subscriptions" element={<SubscriptionIndex />} />
            <Route path="/user/info/invoice" element={<InvoiceIndex />} />
            <Route path="/user/info/incomes" element={<IncomesIndex />} />
            <Route path="/user/info/withdraw" element={<WithdrawIndex />} />
            <Route path="/user/info/sms" element={<SmsLogs />} />
            <Route path="/user/setting/watermark" element={<Watermark />} />
            <Route path="/user/setting/resolution" element={<Resolution />} />
            <Route path="/user/setting/tag" element={<Tag />} />
            <Route path="/" element={<Navigate to={hasToken ? '/user/orders' : '/login'} replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </main>
      <WxLinkDialog
        open={userStore.wechatDialogOpen}
        onClose={userStore.setWechatDialogOpen.bind(userStore, false)}
      />
      <DeleteConfirmationDialog />
      <ChargeDialog />
      <SubscriptionAlert />
      <SpaceAlert />
    </div>
  );
}));

export default Layout;
